import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobile", "desktop"]

  toggle() {
    if (this.mobileTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this._trigger = document.activeElement
    this.mobileTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    const backdrop = this.mobileTarget.querySelector("[data-sidebar-backdrop]")
    const panel = this.mobileTarget.querySelector("[data-sidebar-panel]")
    if (backdrop) backdrop.classList.add("animate-fade-in")
    if (panel) panel.classList.add("animate-slide-up")

    this._escHandler = this.handleEscape.bind(this)
    this._trapHandler = this.trapFocus.bind(this)
    document.addEventListener("keydown", this._escHandler)
    document.addEventListener("keydown", this._trapHandler)

    const firstFocusable = (panel || this.mobileTarget).querySelector("a, button")
    firstFocusable?.focus()
  }

  close() {
    const backdrop = this.mobileTarget.querySelector("[data-sidebar-backdrop]")
    const panel = this.mobileTarget.querySelector("[data-sidebar-panel]")

    if (backdrop) {
      backdrop.classList.remove("animate-fade-in")
      backdrop.classList.add("animate-fade-out")
    }
    if (panel) {
      panel.classList.remove("animate-slide-up")
      panel.classList.add("animate-slide-down")
    }

    if (this._escHandler) {
      document.removeEventListener("keydown", this._escHandler)
      this._escHandler = null
    }
    if (this._trapHandler) {
      document.removeEventListener("keydown", this._trapHandler)
      this._trapHandler = null
    }

    setTimeout(() => {
      this.mobileTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")

      if (backdrop) backdrop.classList.remove("animate-fade-out")
      if (panel) panel.classList.remove("animate-slide-down")
    }, 200)

    this._trigger?.focus()
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  trapFocus(event) {
    if (event.key !== "Tab") return
    const panel = this.mobileTarget.querySelector("[data-sidebar-panel]") || this.mobileTarget
    const focusable = panel.querySelectorAll("a, button, input, [tabindex]:not([tabindex=\"-1\"])")
    if (focusable.length === 0) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
